export interface TroubleshootingStep {
  key: string;
  question?: string;
  showIntro?: boolean;
  images?: TroubleshootingImage[];
  optionsLabel?: string;
  options: TroubleshootingOption[];
  label?: any;
}

export interface TroubleshootingImage {
  url: string;
  alt: string;
  video?: string;
}

export interface TroubleshootingOption {
  key: string;
  option: string;
  icon?: 'check' | 'cross' | 'question' | 'truck' | 'chevronRight';
  steps?: TroubleshootingStep[];
  resolve?: boolean;
  label?: any;
}

export const optionYes: TroubleshootingOption = {
  key: 'es-2000-yes',
  option: 'troubleshooting.yes',
  icon: 'check',
  resolve: true,
  label: ['Yes', 'Si', 'Oui', 'Ja', 'Sì', 'はい', 'Sim', 'Ja'],
};

export const optionResolved: TroubleshootingOption = {
  key: 'es-2000-resolved',
  option: 'troubleshooting.resolved',
  icon: 'check',
  resolve: true,
  label: [
    'Resolved',
    'Resuelto',
    'Résolue',
    'Opgelost',
    'Risolto',
    '解決済み',
    'Resolvido',
    'Gelöst',
  ],
};

export const optionStart: TroubleshootingOption = {
  key: 'es-2000-start',
  option: 'troubleshooting.start',
  icon: 'check',
  label: [
    'Start',
    'Comenzar',
    'Commencer',
    'Starten',
    'Avvia',
    '開始',
    'Iniciar',
    'Starten',
  ],
};

export const optionNo: TroubleshootingOption = {
  key: 'es-2000-no',
  option: 'troubleshooting.no',
  icon: 'cross',
  label: ['No', 'No', 'Non', 'Nee', 'No', 'いいえ', 'Não', 'Nein'],
};

export const optionNext: TroubleshootingOption = {
  key: 'es-2000-next',
  option: 'troubleshooting.next',
  icon: 'chevronRight',
  label: [
    'Next',
    'Siguiente Paso',
    'Suivante',
    'Volgende',
    'Avanti',
    '次へ',
    'Próximo',
    'Weiter',
  ],
};

export const optionEnd: TroubleshootingOption = {
  key: 'es-2000-end',
  option: 'troubleshooting.requestHelp',
  icon: 'truck',
  label: ['End', 'Fin', 'Fin', 'Einde', 'Fine', '終了', 'Finalizar', 'Beenden'],
};

export const optionCant: TroubleshootingOption = {
  key: 'es-2000-cannot-complete',
  option: 'troubleshooting.cannotComplete',
  label: [
    'Cannot complete this step',
    'No puedo completar este paso',
    'Impossible de compléter cette étape',
    'Kan deze stap niet voltooien',
    'Impossibile completare questo passaggio',
    'この手順を完了できません',
    'Não é possível concluir esta etapa',
    'Dieser Schritt kann nicht abgeschlossen werden',
  ],
  icon: 'cross',
  resolve: false,
  steps: [],
};
